import React from "react";

export default function PhotoCard({ img }) {
  return (
    <div
    >
      <div className="">
        <img
          className=''
          src={img}
        />
      </div>
    </div>
  );
}
